import moment from 'moment'

export const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const base64ToBlob = (dataURI) => {
    const byteString = window.atob(dataURI)
    const arrayBuffer = new ArrayBuffer(byteString.length)
    const int8Array = new Uint8Array(arrayBuffer)
    for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i)
    }
    const blob = new Blob([int8Array], {type: 'application/pdf'})
    return blob
}

const downloadBase64File = (blob, fileName) => {
    let dwldLink = document.createElement('a')
    let url = URL.createObjectURL(blob)
    dwldLink.setAttribute('href', url)
    dwldLink.setAttribute('download', fileName)
    dwldLink.style.visibility = 'hidden'
    document.body.appendChild(dwldLink)
    dwldLink.click()
    document.body.removeChild(dwldLink)
}

export const download = (base64, fileName) => {
    const blob = base64ToBlob(base64)

    downloadBase64File(blob, fileName)
}

export const OpenFileInNewTab = (base64) => {
    const file = base64ToBlob(base64)

    console.log('file', file)
    const fileURL = URL.createObjectURL(file)
    console.log('file url', fileURL)
    const pdfWindow = window.open()
    pdfWindow.location.href = fileURL
}

export const getDashboardPeriods = (format = 'YYYY-MM-DD') => {
    const today = moment().format(format)
    const pastWeek = moment().subtract(7, 'days').format(format)
    const monthAgo = moment().subtract(30, 'days').format(format)
    const past90Days = moment().subtract(90, 'days').format(format)
    return {today, pastWeek, monthAgo, past90Days}
}

export const getFullAddress = (address) => {
    const {city = '', street = '', housenumber = ''} = address ?? {}
    return `${street} ${housenumber} ${city}`.trim()
}

export const getFullName = (user) => {
    const {firstname = '', lastname = ''} = user ?? {}
    return `${firstname} ${lastname}`.trim()
}

export const imageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = () => {
            const base64Image = reader.result

            resolve(base64Image)
        }

        reader.onerror = () => {
            reject(new Error('Failed to convert image to base64'))
        }

        reader.readAsDataURL(file)
    })
}

export const copyTextToClipboard = (text) => {
    navigator.clipboard.writeText(text)
}

export const boolToNum = (value) => (value ? 1 : 0)
